

  import {Component, Vue, Watch} from "vue-property-decorator";
  import PagedTableView from "@/components/PagedTableView/index.vue";
  import api from '@/api'
  import UploadTemplate from "@/components/UploadTemplate/index.vue";
  import SalaryDetail from "@/views/pays/payroll/salary/detail.vue";
  import {OrganizationUnitDto, SalaryDto} from "@/api/appService";
  import ExportButton from "@/components/ExportButton/index.vue";

  @Component({name:'SalaryList',
    components: {ExportButton, SalaryDetail, UploadTemplate, PagedTableView}
  })
  export default class SalaryList extends Vue{

    queryForm:any = {
      year:undefined,
      month:undefined,
      name:'',
      job:'',
    };

    currentItem:any = {};

    yearMonth:string ='';

    created(){
      const now = new Date();
      this.yearMonth = '';
      // this.queryForm.year = now.getFullYear();
      // this.queryForm.month = now.getMonth()+1;
      //
      // this.yearMonth = `${this.queryForm.year}-${this.queryForm.month}`;
    }

    fetchData(params:any){
      return api.salary.getAll(params);
    }

    get isBigArea(){
      return (this.$store.getters['user/ou'] as OrganizationUnitDto) .level === '大区';
    }

    @Watch("yearMonth")
    handleYearMonthChange(newValue:Date){
      if(newValue){
        this.queryForm.year = newValue.getFullYear();
        this.queryForm.month = newValue.getMonth()+1;
      } else {
        this.queryForm.year = undefined;
        this.queryForm.month = undefined;
      }

    }

    handleViewDetail(row:any){
      this.currentItem = row;
      (this.$refs.salaryDetail as any).show = true;
    }
    handleDelete(id:number){
      this.$confirm("您确认要删除此项吗？").then(() => {
        api.salary
          .delete({
            id: id
          })
          .then(res => {
            this.$message({
              type: "success",
              message: "删除成功"
            });
          });
      });
    }
  }
